import { useState, useEffect } from "react";

import { setDebugInfo } from "../utils/debugHelper";

function getScreenDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

export default function useScreenDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getScreenDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getScreenDimensions());
      setDebugInfo("screenDimensions", getScreenDimensions());
    }

    setDebugInfo("screenDimensions", getScreenDimensions());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
